/**
 * Toggle switch. Verbatim: track 38x22 (small 34x20), knob 18 (small 16) at
 * top 2, knobX 2/18 (small 2/16), white knob with shadow. Animated via CSS
 * transition on the web layer (left/background).
 */
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { colors, radii } from '../theme';

// `disabled` added for the FE↔BE integration (Round 3): the grant drawer shows
// non-grantable bindings (no canonical entity in catalog v1) as a visibly inert
// toggle. Optional + defaults to false, so existing call sites are unaffected.
type Props = { on: boolean; onToggle: () => void; small?: boolean; trackOn?: string; disabled?: boolean };

export default function Toggle({ on, onToggle, small = false, trackOn = colors.accent, disabled = false }: Props) {
  const tw = small ? 34 : 38;
  const th = small ? 20 : 22;
  const k = small ? 16 : 18;
  const onX = small ? 16 : 18;
  return (
    // When disabled, ignore presses and dim/show not-allowed cursor.
    <Pressable onPress={disabled ? undefined : onToggle} style={[styles.wrap, disabled && ({ opacity: 0.4, cursor: 'not-allowed' } as any)]}>
      <View
        style={[
          { width: tw, height: th, borderRadius: radii.full, backgroundColor: on ? trackOn : colors.lineStrong, transition: 'background 180ms' } as any,
        ]}
      >
        <View
          style={[
            styles.knob,
            { width: k, height: k, left: on ? onX : 2, transition: 'left 180ms cubic-bezier(0.2,0.8,0.2,1)' } as any,
          ]}
        />
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  wrap: { cursor: 'pointer' } as any,
  knob: {
    position: 'absolute',
    top: 2,
    borderRadius: 999,
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgba(16,24,40,0.25)',
  } as any,
});
